import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SyncEntitiesRequest } from '@cash-web/shared-util-protos/squareup/franklin/SyncEntitiesRequestProto.pb'
import { SyncEntitiesResponse } from '@cash-web/shared-util-protos/squareup/franklin/SyncEntitiesResponseProto.pb'

export const syncEntities = (request: SyncEntitiesRequest, options?: CashRequestOptions) =>
  post<SyncEntitiesRequest, SyncEntitiesResponse>('/2.0/cash/sync-entities', request, {
    ...options,
    rejectOnError: true,
  })
